<template>
  <div class="ti d-flex">
<!--    <div class="d-flex-left">-->

<!--    </div>-->
    <div class="d-flex-right">
      <div class="header">
        <div style="margin: 5px 0">
          <div>
            <SelectCdjProjectHeader @onHeader="onHeader">
              <el-select size="mini" placeholder="账龄类型" clearable v-model="reginWhere.age">
<!--                <el-option :value="1" label="当期"></el-option>-->
<!--                <el-option :value="2" label="纯上一年"></el-option>-->
                <el-option :value="3" label="1年以上2年以内"></el-option>
                <el-option :value="4" label="2年以上"></el-option>
<!--                <el-option :value="5" label="1年以上"></el-option>-->
              </el-select>
              <el-input
                size="mini"
                style="width: 240px"
                placeholder="请输入房产/管家名称/业主名称"
                v-model="where.text"
                clearable>
              </el-input>
              <el-date-picker
                style="width: 150px"
                v-model="where.start_time"
                size="mini"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
              <el-date-picker
                style="width: 150px"
                v-model="where.end_time"
                size="mini"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </SelectCdjProjectHeader>
          </div>
        </div>
      </div>

      <el-tabs type="border-card" v-model="card_index">
        <el-tab-pane label="催费跟进" name="LegalLitigationLayout">
          <!--          <LegalHousePlanUnit v-if="card_index==='LegalHousePlanUnit'" :urge_type="2" @exportExcelNote="exportExcelNote" />-->
          <LegalLitigationLayout v-if="card_index==='LegalLitigationLayout'" />
        </el-tab-pane>
        <el-tab-pane label="催费登记" name="list">
          <LegalLitigationList v-if="card_index==='list'&&is_loading" />
        </el-tab-pane>
        <el-tab-pane label="近12月统计" name="tj">
          <LegalLitigationStatistics v-if="card_index==='tj'" ref="LegalStatistics" :projectIds="reginWhere.project_ids" :typeId="reginWhere.type_id" :regionId="reginWhere.project_region" :projectId="reginWhere.project_name" :areaId="reginWhere.area_id"  />
        </el-tab-pane>
        <el-tab-pane label="近30日统计" name="rtj">
          <LegalLitigationStatistics30day v-if="card_index==='rtj'" ref="LegalStatistics30Day" :projectIds="reginWhere.project_ids" :typeId="reginWhere.type_id" :regionId="reginWhere.project_region" :projectId="reginWhere.project_name" :areaId="reginWhere.area_id"  />
        </el-tab-pane>
<!--        <el-tab-pane label="催费排名统计表" name="pm">-->
<!--          <LegalRanking v-if="card_index==='pm'" :projectIds="reginWhere.project_ids" :typeId="reginWhere.type_id" :regionId="reginWhere.project_region" :projectId="reginWhere.project_name" :areaId="reginWhere.area_id" :start_time="where.start_time" :end_time="where.end_time"/>-->
<!--        </el-tab-pane>-->
        <el-tab-pane label="催缴力统计表" name="StatisticalTableOfCollectionForce">
          <StatisticalTableOfCollectionForce v-if="card_index==='StatisticalTableOfCollectionForce'" :age_type="[3,4]"/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import LegalLitigationStatistics from "./components/legal_litigation/LegalLitigationStatistics";
import LegalRanking from "./components/LegalRanking";
import LegalLitigationStatistics30day from "./components/legal_litigation/LegalLitigationStatistics30day";
import CompletionRate from "./components/legal/CompletionRate";
import CompletionRateYearMonth from "./components/legal/CompletionRateYearMonth";
import AgingType from "./components/common/AgingType";
import StatisticalTableOfCollectionForce from "./components/report_forms/StatisticalTableOfCollectionForce";
import LegalLitigationList from "./components/legal_litigation/LegalLitigationList";
import LegalHousePlanUnit from "./components/plan/LegalHousePlanUnit";
import SelectCdjProjectHeader from "./components/common/SelectCdjProjectHeader";
import LegalLitigationLayout from "./components/plan/LegalLitigationLayout";

export default {
  name: "LegalLitigation",
  components: {
    LegalLitigationLayout,
    SelectCdjProjectHeader,
    LegalHousePlanUnit,
    LegalLitigationList,
    StatisticalTableOfCollectionForce,
    AgingType,
    CompletionRateYearMonth, CompletionRate, LegalLitigationStatistics30day, LegalRanking, LegalLitigationStatistics},
  provide(){
    return{
      where:this.where,
      reginWhere:this.reginWhere
    }
  },
  data() {
    return {
      is_loading: false,
      loading: false,
      where: {
        text:"",
        type:"",
        type_ex:"",
        start_time:moment(new Date()).format("YYYY-MM-DD"),
        end_time:moment(new Date()).format("YYYY-MM-DD")
      },
      type_list:[],
      project_region_list:[],
      reginWhere:{
        type_id:"",
        type_list:[],
        project_region:"",
        project_region_list:[],
        project_region_level:"",
        project_name:"",
        project_list:[],
        group_by:"",
        area_id:"",
        area_list:[],
        project_ids:[],
        age:3
      },
      card_index:"LegalLitigationLayout",
    }
  },
  mounted() {

  },
  activated() {
    const that=this;

    if(that.$route.query.card_index){
      that.card_index=that.$route.query.card_index
    }
  },
  methods: {
    getLegalStatistics(){
      const  that=this;
      setTimeout(function () {
        that.card_index==='tj'&&that.$refs.LegalStatistics&&that.$refs.LegalStatistics.reData();
      },50)
    },
    getLegalStatistics30Day(){
      const  that=this;
      setTimeout(function () {
        that.card_index==='rtj'&&that.$refs.LegalStatistics30Day&&that.$refs.LegalStatistics30Day.reData();
      },50)
    },
    onHeader(data){
      const that=this;
      that.reginWhere.type_id=data.type_id;
      that.reginWhere.type_list=data.type_list;
      that.reginWhere.project_region=data.project_region;
      that.reginWhere.project_region_list=data.project_region_list;
      that.reginWhere.project_region_level=data.project_region_level;
      that.reginWhere.project_name=data.project_name;
      that.reginWhere.project_list=data.project_list;
      that.reginWhere.group_by=data.group_by;
      that.reginWhere.area_id=data.area_id;
      that.reginWhere.area_list=data.area_list;
      that.reginWhere.project_ids=data.project_ids;
      that.reginWhere.level=data.level;
      that.is_loading=true;

      that.getLegalStatistics()
      that.getLegalStatistics30Day()
    }
  },
  watch:{
    card_index(n){
      if(n==='tj'){
        this.getLegalStatistics()
      }else if(n==='rtj'){
        this.getLegalStatistics30Day()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "common";

.m-2{
  width: 150px;
}
.ti {
  margin: 1%;
  width: 98%;
}

.text1 {
  text-align: center;
}

.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}

.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}

.text2 {
  color: rgb(250, 248, 248);
}

.kuan {
  width: 10%;
}

.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  margin: 30px;
  width: calc( 100% - 10px );
  overflow-y: scroll;
  height: calc( 100vh - 150px );

  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }



  >>>.el-tabs__item{
    color: black;
  }
}
.view-file-win{
  height: 60vh;
  overflow-y: scroll;
  .main-log{
    margin: 10px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/LegalLitigation.vue